@if (disabled) {
  <checkbox-container>
    <div class="checkbox-wrapper checkbox-container">
      <div class="checkbox-box pr-input-label"></div>
      <div class="checkbox-label">{{ label }}</div>
    </div>
  </checkbox-container>
} @else {
  <checkbox-container (click)="toggleCheck()">
    <input
      [checked]="maxSelected ? null : isChecked()"
      class="checkbox-input horizontal"
      type="checkbox"
      [id]="formLabel"
      (click)="toggleCheck()"
      [attr.disabled]="maxSelected ? isDisabled() : null"
    />
    <label style="width: 100%" [for]="formLabel" class="checkbox-container">
      <span class="pr-input-label">{{ label }}</span>
    </label>
  </checkbox-container>
}
